module.exports = __webpack_public_path__ + "img/es.ae9b0e11.svg";